// Lib
import { curryN } from 'lodash/fp';

export default curryN(2, (predicateArray = [], args) =>
    predicateArray.reduce((passing, predicateFn) => passing && predicateFn(args), true),
);
